import styled, { css } from 'styled-components';

import { NeutralColors } from '@/theme';

export const SidebarMenuItem = styled.li<{
  $isActive: boolean;
  $isMenuCollapsed?: boolean;
  $color?: string;
  $activeColor?: string;
  $activeBackgroundColor?: string;
}>`
  display: grid;
  grid-template-columns: 2px 62px 1fr auto;
  align-items: center;
  height: 40px;
  position: relative;
  color: ${({ color }) => color || NeutralColors[40]};

  span {
    font-size: 14px;
    overflow: hidden;
    position: static;
    text-overflow: ellipsis;
    transition:
      opacity 0.5s ease-in-out,
      visibility 0.1s ease-in-out;
    opacity: ${props => (props.$isMenuCollapsed ? '0' : '1')};
    display: ${props => (props.$isMenuCollapsed ? 'none' : 'inline')};
  }

  svg {
    align-self: center;
    justify-self: center;
  }

  &:hover {
    color: ${({ $activeColor }) => $activeColor};
    font-weight: 500;
    cursor: pointer;
  }

  ${({ $isActive, $activeColor, $activeBackgroundColor }) =>
    $isActive &&
    css`
      color: ${$activeColor};
      background-color: ${$activeBackgroundColor};
      &:before {
        background: #fff;
        border-radius: 0 4px 4px 0;
        content: '';
        height: 30px;
        left: 0;
        position: absolute;
        top: 6px;
        width: 4px;
      }
    `}
`;

export const SidebarSubMenuItem = styled.li<{
  $isActive: boolean;
  $isMenuCollapsed?: boolean;
  $color?: string;
  $activeColor?: string;
  $activeBackgroundColor?: string;
}>`
  display: flex;
  align-items: center;
  padding-left: 64px;
  position: relative;
  color: ${({ $color }) => $color || NeutralColors[40]};

  span {
    font-size: 14px;
    padding: 10px 0;
    overflow: hidden;
    position: static;
    text-overflow: ellipsis;
    transition:
      opacity 0.5s ease-in-out,
      visibility 0.1s ease-in-out;
  }

  &:hover {
    color: ${({ $activeColor }) => $activeColor};
    font-weight: 500;
    cursor: pointer;
  }

  ${({ $isActive, $activeColor, $activeBackgroundColor }) => {
    if ($isActive) {
      return css`
        color: ${$activeColor};
        background-color: ${$activeBackgroundColor};
        &:before {
          background: #fff;
          border-radius: 0 4px 4px 0;
          content: '';
          height: 30px;
          left: 0;
          position: absolute;
          top: 6px;
          width: 4px;
        }
      `;
    }

    return ``;
  }}
`;

export const CollapseButton = styled.button<{ $isOpen?: boolean }>`
  border: 0;
  margin: 0 16px 0 0;
  padding: 0;
  cursor: pointer;
  background-color: transparent;
  height: 24px;
  transform: ${props => (props.$isOpen ? 'rotate(0deg)' : 'rotate(180deg)')};
  transition:
    all 0.2s,
    background 0s;
`;

export const CollapseContent = styled.div<{ $isOpen?: boolean }>`
  display: ${props => (props.$isOpen ? 'flex' : 'none')};
  flex-direction: column;
  gap: 4px;
`;

export const CollapseContentExpanded = styled.div<{
  isOpen?: boolean;
}>`
  overflow: hidden;
`;

export const SidebarMenuItemActiveMark = styled.div<{
  $isActive?: boolean;
  $backgroundColor?: string;
}>`
  background-color: ${({ $backgroundColor }) => $backgroundColor};
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
  width: 2px;
  height: 24px;
  opacity: ${props => (props.$isActive ? '1' : '0')};
`;
